import add from '@material-symbols/svg-600/outlined/add.svg';
import add_circle from '@material-symbols/svg-600/outlined/add_circle.svg';
import arrow_back from '@material-symbols/svg-600/outlined/arrow_back.svg';
import arrow_drop_down from '@material-symbols/svg-600/outlined/arrow_drop_down.svg';
import calendar_month from '@material-symbols/svg-600/outlined/calendar_month.svg';
import calendar_today from '@material-symbols/svg-600/outlined/calendar_today.svg';
import cancel_filled from '@material-symbols/svg-600/outlined/cancel-fill.svg';
import cancel from '@material-symbols/svg-600/outlined/cancel.svg';
import check_circle_filled from '@material-symbols/svg-600/outlined/check_circle-fill.svg';
import check_circle from '@material-symbols/svg-600/outlined/check_circle.svg';
import close from '@material-symbols/svg-600/outlined/close.svg';
import delete_icon from '@material-symbols/svg-600/outlined/delete.svg';
import edit from '@material-symbols/svg-600/outlined/edit.svg';
import error_filled from '@material-symbols/svg-600/outlined/error-fill.svg';
import error from '@material-symbols/svg-600/outlined/error.svg';
import flight_land from '@material-symbols/svg-600/outlined/flight_land.svg';
import flight_takeoff from '@material-symbols/svg-600/outlined/flight_takeoff.svg';
import info_filled from '@material-symbols/svg-600/outlined/info-fill.svg';
import info from '@material-symbols/svg-600/outlined/info.svg';
import keyboard_arrow_up from '@material-symbols/svg-600/outlined/keyboard_arrow_up.svg';
import local_fire_department from '@material-symbols/svg-600/outlined/local_fire_department.svg';
import loyalty from '@material-symbols/svg-600/outlined/loyalty.svg';
import refresh from '@material-symbols/svg-600/outlined/refresh.svg';
import search from '@material-symbols/svg-600/outlined/search.svg';
import star from '@material-symbols/svg-600/outlined/star.svg';
import thumb_up from '@material-symbols/svg-600/outlined/thumb_up.svg';
import verified_user from '@material-symbols/svg-600/outlined/verified_user.svg';

export const IconMap = {
  search,
  keyboard_arrow_up,
  check_circle,
  cancel,
  verified_user,
  edit,
  calendar_month,
  info,
  add,
  delete_icon,
  add_circle,
  error,
  arrow_back,
  flight_takeoff,
  flight_land,
  arrow_drop_down,
  calendar_today,
  thumb_up,
  star,
  loyalty,
  refresh,
  close,
  info_filled,
  check_circle_filled,
  error_filled,
  cancel_filled,
  local_fire_department,
};
